import { createModule } from 'saga-slice';

const sagaSlice = createModule({
    name: 'sidebar',
    initialState: {
        width: '210px',
        visible: true,
        error: null,
        menuItemIndex: -1
    },

    reducers: {
        toggleSidebar: state => {
            state.width = state.width === '0px' ? '210px' : '0px';
            state.visible = !state.visible;
        },
        activeMenuItem: (state, payload) => {

            state.menuItemIndex = payload;
        }
    }
});

export const { actions } = sagaSlice;
export default sagaSlice;
